import { useState, useEffect } from 'react';

const AUTOCOMPLETE_SETTING_KEY = 'enableLocationAutocomplete';

export const useAutocompleteSettings = () => {
  const [enableAutocomplete, setEnableAutocomplete] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem(AUTOCOMPLETE_SETTING_KEY);
    if (saved !== null) {
      setEnableAutocomplete(JSON.parse(saved));
    }
  }, []);

  return enableAutocomplete;
};